// https://github.com/marcuswestin/store.js
define('shared/lib/store',['shared/lib/JSON3', './store.source'], function(JSON3, source){
    return source;
} ); 

